import React from 'react';

type SimpleLabelValueProps = {
  label?: React.ReactNode;
  value?: string;
  fallback?: string;
};

const SimpleLabelValue = ({ label, value, fallback }: SimpleLabelValueProps) => {
  if (!label || !value) return fallback || null;
  return (
    <div>
      {label} <span style={{ opacity: 0.5 }}>[{value}]</span>
    </div>
  );
};

export default SimpleLabelValue;
